import { GLOSSARY_DATA } from '@freight-cbm/shared-logic';

export function GlossarySection() {
  const sorted = [...GLOSSARY_DATA].sort((a, b) => a.term.localeCompare(b.term));

  return (
    <div>
      <h3 className="section-title">Freight Terminology Glossary</h3>
      <div style={{ display: 'grid', gap: 'var(--space-2)' }}>
        {sorted.map((item) => (
          <div
            key={item.term}
            style={{
              padding: 'var(--space-2) var(--space-3)',
              background: 'var(--color-bg-secondary)',
              borderRadius: 'var(--radius-md)',
            }}
          >
            <strong style={{ fontSize: 'var(--font-size-sm)' }}>{item.term}</strong>
            <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)', margin: 'var(--space-1) 0 0' }}>
              {item.definition}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
